import React from 'react';

export default () => (
  <svg
    width='61'
    height='61'
    viewBox='0 0 61 61'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clip-path='url(#clip0_11428_19158)'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M34.4095 4.94995L19.0645 14.985V40.095H30.1795V28.89C30.1795 26.55 32.0695 24.66 34.4095 24.66C36.7495 24.66 38.6395 26.55 38.6395 28.89V40.095H49.7545V14.985L34.4095 4.94995Z'
        fill='#97D700'
      />
      <path
        d='M55.9105 32.382C55.2505 31.962 54.3506 31.962 53.6906 32.382L36.6505 41.622C35.4505 42.282 34.0105 42.402 32.6905 41.862L26.0305 39.402C25.4905 39.222 25.3705 38.442 25.9105 38.142C26.0905 38.022 26.3305 38.022 26.5105 38.082L31.5505 40.002C32.6905 40.422 34.0705 40.122 34.7905 39.102C35.8105 37.722 35.2105 35.802 33.6505 35.142L25.1905 31.602C24.5305 31.302 23.8105 31.362 23.1505 31.602L14.8105 35.202C14.8105 35.202 14.8105 35.202 14.8105 35.262V41.442V49.662V49.722L32.6905 53.922C33.7705 54.282 34.9105 54.042 35.7505 53.322L56.1505 35.802C57.1705 34.782 57.1105 33.162 55.9105 32.382Z'
        fill='#DFF3B2'
        stroke='black'
        stroke-width='2'
      />
      <path d='M14.7509 33.822H4.13086V51.522H14.7509V33.822Z' fill='#06292F' />
    </g>
    <defs>
      <clipPath id='clip0_11428_19158'>
        <rect
          width='60'
          height='60'
          fill='white'
          transform='translate(0.5 0.0419922)'
        />
      </clipPath>
    </defs>
  </svg>
);
